import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customDate' })
export class CustomDatePipe implements PipeTransform {
  transform(value: any): Date | null {
    if (!value) return null;

    if (value instanceof Date) {
      return value;
    }

    if (typeof value === 'string' && value.includes('T')) {
      const [year, month, day] = value.split('T')[0].split('-').map(Number);
      const adjustedDate = new Date(year, month - 1, day);

      return adjustedDate;
    }

    // YYYY-MM-DD (p. ej. startDateService de Ticketería)
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
      const [year, month, day] = value.trim().split('-').map(Number);
      return new Date(year, month - 1, day);
    }

    if (typeof value === 'string' && value.includes('/')) {
      const parts = value.split('/');

      return new Date(+parts[2], +parts[1] - 1, +parts[0]);
    }

    return null;
  }
}
